module.exports = __webpack_public_path__ + "img/chivas-crystal-bottle-age.e2d7dd48.png";